import "./deal.css";
import { Box, Typography, Button, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Swiper, SwiperSlide } from "swiper/react";
// import Swiper core and required modules
import { Keyboard, Pagination } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import { useEffect, useRef, useState } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// MUI LAB
import ProductSmall from "../product/ProductSmall";
import HowToOrder from "./HowToOrder";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import HowToVid from "../misc/HowToVid";

import { useDispatch, useSelector } from "react-redux";
import LoadingBox from "../misc/Loading";
import { setIdToScroll } from "../../reduxToolkit/features/miscFront";
import { mergeMedicineList } from "../../hooks/mergeMedicineList";
import { mergeManagedContent } from "../../hooks/mergeManagedContent";
import { colors, fonts, radii, shadows } from "../../theme/designTokens";

export default function Deal() {
  const dispatch = useDispatch();
  // Responsive
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  // Use States
  const [howToVid, setHowToVid] = useState(false);
  const [contentSettings, setContentSettings] = useState([]);
  const [langId, setLangId] = useState("");

  const { managedContentSettings } = useSelector(
    (state) => state.managedContentSettings
  );
  const { langs } = useSelector((state) => state.misc);

  // ! ============== Medicine Section
  const [lang, setLang] = useState("en");
  const [medLoading, setMedLoading] = useState(false);
  const [medList, setMedList] = useState([]);
  const [catList, setCatList] = useState([]);

  // store
  const { medicines, categories, viewCountArr } = useSelector(
    (state) => state.medicine
  );
  const { activeLangFront } = useSelector((state) => state.miscFront);

  // Use Effect
  useEffect(() => {
    // if (!(medicines && medicines.length > 0)) dispatch(getMedicines());
    // if (!(categories && categories.length > 0)) dispatch(getMedCategories());
  }, []);

  // Set Medicine
  useEffect(() => {
    setMedLoading(true);
    if (lang !== "" && medicines && medicines.length > 0) {
      const mergedData = mergeMedicineList(medicines, lang);
      if (mergedData.length > 0) {
        let arr = [];
        mergedData.forEach((x) => {
          let obj = { ...x };
          const C = viewCountArr.find(
            (c) =>
              c.medicineIdEn ===
              (lang !== "en" ? x.medicineDetectorId : x.fixedMedicineId)
          );
          if (C) obj.viewCount = C.viewCount;
          else obj.viewCount = 0;
          arr.push(obj);
        });
        arr = arr.filter((m) => m.visible === true);
        arr = arr.sort((a, b) => (a.viewCount < b.viewCount ? 1 : -1));
        if (arr) arr = arr.slice(0, 10);
        setMedList(arr);
      } else setMedList([]);
    }
    if (medicines) {
      setTimeout(() => {
        setMedLoading(false);
      }, 1000);
    }
  }, [medicines, lang, viewCountArr]);

  // set Category
  useEffect(() => {
    if (lang !== "" && categories && categories.length > 0) {
      let C = categories.find((c) => c.lang === lang);
      if (C) setCatList(C.data);
      else setCatList([]);
    }
  }, [categories, lang]);

  // Set Language
  useEffect(() => {
    if (activeLangFront) {
      setLang(activeLangFront.langCode);
      setLangId(activeLangFront._id);
    }
  }, [activeLangFront]);
  // ! ============== Medicine Section

  // ! ============== Scroll functionality
  const howToOrderRef = useRef();

  const { idToScroll } = useSelector((state) => state.miscFront);

  useEffect(() => {
    if (idToScroll === "how-to-order") {
      setTimeout(() => {
        howToOrderRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
          top: 20,
        });
        dispatch(setIdToScroll(""));
      }, 250);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idToScroll]);
  // ! ============== Scroll functionality

  // Set Settings
  useEffect(() => {
    if (
      managedContentSettings &&
      managedContentSettings.length > 0 &&
      langId !== ""
    ) {
      const M = mergeManagedContent(managedContentSettings, langId, langs);
      if (M) setContentSettings(M);
    }
  }, [langId, managedContentSettings]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  return (
    <>
      <Box sx={{ maxWidth: 1600, mx: "auto", px: { xs: 2, sm: 3 }, py: { xs: 4, md: 6 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: radii.md,
              bgcolor: colors.primaryLight,
              color: colors.primary,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <VisibilityOutlinedIcon fontSize="small" />
          </Box>
          <Typography sx={{ fontFamily: fonts.display, fontWeight: 800, fontSize: "1.25rem", color: colors.ink }}>
            {translateFront("Most Viewed")}
          </Typography>
        </Box>

        {medLoading ? (
          <LoadingBox w={"100%"} h={"600px"} />
        ) : (
          <Swiper
            slidesPerView={!smUp ? 1 : !mdUp ? 2 : 4}
            grabCursor
            modules={[Keyboard, Pagination]}
            spaceBetween={20}
            pagination={{ clickable: true }}
            className="deal"
          >
            {medList.map((x, i) => (
              <SwiperSlide key={i}>
                <ProductSmall
                  x={x}
                  i={i}
                  view={0}
                  catList={catList}
                  lang={lang}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </Box>

      <Box sx={{ bgcolor: colors.primaryDark, position: "relative" }}>
        <Box
          ref={howToOrderRef}
          sx={{ position: "absolute", top: -300, height: 300 }}
        />
        <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3 }, py: { xs: 5, md: 7 } }}>
          <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", flexWrap: "wrap", gap: 2, mb: 3.5 }}>
            <Box>
              <Typography sx={{ fontFamily: fonts.display, fontWeight: 800, fontSize: "1.4rem", color: "#fff" }}>
                {translateFront("How To Order")}
              </Typography>
              <Typography sx={{ fontSize: 13.5, color: "rgba(255,255,255,0.75)", mt: 0.5 }}>
                Simple steps, start to finish
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<OndemandVideoIcon />}
              onClick={() => setHowToVid(true)}
              sx={{
                bgcolor: "#fff",
                color: colors.primaryDark,
                textTransform: "none",
                fontWeight: 700,
                borderRadius: radii.md,
                boxShadow: "none",
                "&:hover": { bgcolor: "rgba(255,255,255,0.9)", boxShadow: "none" },
              }}
            >
              {translateFront("Watch Video")}
            </Button>
          </Box>
          <HowToOrder dark />

          {howToVid && (
            <Dialog
              open={howToVid}
              onClose={() => setHowToVid(false)}
              aria-labelledby={"about-us-video"}
              maxWidth="md"
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: radii.lg,
                  bgcolor: colors.ink,
                  boxShadow: shadows.cardHover,
                  overflow: "hidden",
                },
              }}
            >
              <IconButton
                onClick={() => setHowToVid(false)}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  zIndex: 2,
                  color: "#fff",
                  bgcolor: "rgba(255,255,255,0.12)",
                  "&:hover": { bgcolor: "rgba(255,255,255,0.22)" },
                }}
                size="small"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
              <DialogContent sx={{ p: { xs: 1.5, sm: 3 } }}>
                <HowToVid contentSettings={contentSettings} />
              </DialogContent>
            </Dialog>
          )}
        </Box>
      </Box>
    </>
  );
}
